import { Component, OnInit } from '@angular/core';
import { Router }            from '@angular/router';
import { Observable }        from 'rxjs/Observable';
import { Subject }           from 'rxjs/Subject';

import { PlanService } from '../../services/plans/plan.service';

@Component({
  moduleId: module.id,
  selector: 'plan-search',
  templateUrl: 'plan-search.component.html',
  styleUrls: [ '../../users/search/user-search.component.css'  ]
})

export class PlanSearchComponent implements OnInit {

  url:string = '/plan/'
  plans: Observable<any[]>;
  private searchTerms = new Subject<string>();

  constructor(
    protected router: Router,
    protected planService: PlanService) {}

  protected getDetailUrl(): string { return; };
  protected getPlanString(): string { return; };

  // Push a search term into the observable stream.
  search(term: string): void {

    this.searchTerms.next(term);
  }

  ngOnInit(): void {

    this.plans = this.searchTerms
      .debounceTime(300)        // wait for 300ms pause in events
      .distinctUntilChanged()   // ignore if next search term is same as previous
      .switchMap(term => term   // switch to new observable each time
        // return the http search observable
        ? this.planService.search({ name: term })
        // or the observable of empty plans if no search term
        : Observable.of<any[]>([]))
      .catch(error => {
        // TODO: real error handling
        console.log(error);
        return Observable.of<any[]>([]);
      });
  }

  gotoDetail(plan: any): void {
    
    this.router.navigate([ this.url + plan.id ]);
  }
}



// WEBPACK FOOTER //
// ./src/app/plans/search/plan-search.component.ts